/** @jsxImportSource theme-ui */
import { FC } from 'react'
import { Box, Flex, Image, Text } from 'theme-ui'

export interface CardHeaderProps {
  image?: any
  title: string
  description: string
  price?: string
  quantity?: number
  isPreview?: boolean
}

const CardHeader: FC<CardHeaderProps> = ({
  title,
  description,
  price,
  quantity
}) => {
  return (
    <Box
      bg="backgroundAlt"
      sx={{
        borderBottom: '1px solid',
        borderColor: 'pl-gray-light',
        fontFamily: 'body',
        overflow: 'hidden',
        position: 'relative',
        borderRadius: '24px 24px 0 0',
        background: 'pl-gray-background',
      }}
      className="gtm-checkout-add-to-cart"
    >
      <Flex sx={{ alignItems: ['top'], flexDirection: ['row'] }}>
        <Flex
          py={1.5}
          px={['12px', 3]}
          sx={{
            marginTop: '10px',
            alignItems: ['center'],
            flexDirection: ['row'],
            flexGrow: '1',
            justifyContent: 'space-between',
          }}
        >
          <Box>
            <Flex
              sx={{
                mb: [0, '4px'],
                alignItems: 'center',
              }}
            >
              {quantity && (
                <Text
                  sx={{
                    minWidth: '28px',
                    marginRight: '7px',
                    padding: '6px 10px',
                    background: '#7B8D9D',
                    borderRadius: '50%',
                    color: 'pl-gray-white',
                    fontFamily: 'Inter',
                    fontSize: '13px',
                    fontWeight: '700',
                  }}
                >
                  {quantity}
                </Text>
              )}
              {title && (
                <Text
                  as="p"
                  m={0}
                  sx={{
                    marginRight: [2, 0],
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: '600',
                    lineHeight: '22px',
                    textTransform: 'uppercase',
                    color: '#7B8D9D',
                    textWrap: 'nowrap',
                  }}
                >
                  {title}
                </Text>
              )}
            </Flex>
            {description && (
              <Text
                as="p"
                m={0}
                sx={{
                  fontSize: '14px',
                  fontWeight: 'bold',
                  lineHeight: '22px',
                  textTransform: 'uppercase',
                  display: ['none', 'flex'],
                }}
              >
                {description}
              </Text>
            )}
          </Box>
          {price && (
            <Text
              as="p"
              ml={[null, 2]}
              sx={{
                color: 'pl-blue-highlight',
                flexShrink: '0',
                fontSize: '24px',
                fontWeight: 'bold',
                minWidth: '60px',
                textAlign: ['center', 'right'],
              }}
            >
              {price}
            </Text>
          )}
        </Flex>
      </Flex>
    </Box>
  )
}

export default CardHeader
